export const applyPointillismStyle = async (canvas, ctx, setMessage, language) => {
  // 점묘법: 작은 점들로 이미지 구성
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 1. 배경을 흰색으로 초기화
  ctx.fillStyle = 'white';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  
  // 2. 점으로 이미지 재구성
  const dotSize = 3;
  const spacing = 5;
  
  for (let y = 0; y < canvas.height; y += spacing) {
    for (let x = 0; x < canvas.width; x += spacing) {
      const pos = (y * canvas.width + x) * 4;
      
      if (pos < data.length - 4) {
        const r = data[pos];
        const g = data[pos + 1];
        const b = data[pos + 2];
        
        // 색상 분해 - 순수 색으로 분해
        const colors = [];
        
        // 빨간색 성분
        if (r > 50) {
          colors.push({ r: 255, g: 0, b: 0, intensity: r / 255 });
        }
        
        // 녹색 성분
        if (g > 50) {
          colors.push({ r: 0, g: 255, b: 0, intensity: g / 255 });
        }
        
        // 파란색 성분
        if (b > 50) {
          colors.push({ r: 0, g: 0, b: 255, intensity: b / 255 });
        }
        
        // 보조 색상들
        if (r > 50 && g > 50) {
          colors.push({ r: 255, g: 255, b: 0, intensity: Math.min(r, g) / 255 });
        }
        
        if (r > 50 && b > 50) {
          colors.push({ r: 255, g: 0, b: 255, intensity: Math.min(r, b) / 255 });
        }
        
        if (g > 50 && b > 50) {
          colors.push({ r: 0, g: 255, b: 255, intensity: Math.min(g, b) / 255 });
        }
        
        // 점 그리기
        colors.forEach((color, index) => {
          const offsetX = (index % 3 - 1) * 2;
          const offsetY = Math.floor(index / 3) * 2;
          const dotRadius = dotSize * color.intensity;
          
          if (dotRadius > 0.5) {
            ctx.fillStyle = `rgb(${color.r}, ${color.g}, ${color.b})`;
            ctx.beginPath();
            ctx.arc(x + offsetX, y + offsetY, dotRadius, 0, 2 * Math.PI);
            ctx.fill();
          }
        });
      }
    }
  }
  
  // 3. 추가 점들로 디테일 강화
  const detailData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const detailPixels = detailData.data;
  
  for (let i = 0; i < 1000; i++) {
    const x = Math.floor(Math.random() * canvas.width);
    const y = Math.floor(Math.random() * canvas.height);
    const pos = (y * canvas.width + x) * 4;
    
    if (pos < data.length - 4) {
      const r = data[pos];
      const g = data[pos + 1];
      const b = data[pos + 2];
      
      const brightness = (r + g + b) / 3;
      if (brightness > 30) {
        const smallDotSize = Math.random() * 2 + 1;
        ctx.fillStyle = `rgb(${r}, ${g}, ${b})`;
        ctx.beginPath();
        ctx.arc(x, y, smallDotSize, 0, 2 * Math.PI);
        ctx.fill();
      }
    }
  }
};